<app-base-action-modal
  modalTitle="View Past Lump Sum Payments"
  i18n-modalTitle
  primaryLabel="Close"
  i18n-primaryLabel
  [hideSecondary]="true"
  (closeClicked)="close()"
  (primaryClicked)="close()">
  <div class="d-flex flex-column gap-4">
    <ul class="no-style-list d-flex flex-column">
      <li class="payment-row" *ngFor="let payment of pagedPayments$ | async">
        <span class="payment-date">{{ payment.desiredPaymentDate | date : 'MMM yyyy' }}</span>
        <span class="payment-amount">{{ payment.paymentAmount | currency }}</span>
      </li>
    </ul>
    <div class="d-flex justify-content-between align-items-center">
      <app-table-results-text
        [totalCount]="historicalLumpSumPayments.length"
        [pageSize]="pageSize"
        [skip]="(skip$ | async) ?? 0" />
      <app-table-paginator
        [totalCount]="historicalLumpSumPayments.length"
        [pageSize]="pageSize"
        [skip]="(skip$ | async) ?? 0"
        (skipChanged)="onSkipChanged($event)" />
    </div>
  </div>
</app-base-action-modal>
